module.exports = [{"type":"title","text":"2025-12-16"},{"type":"normal","text":"Account API rate limit update.","style":{"font-weight":"bold"},"children":[{"type":"html","text":"Removed IP rate limits for Account API Group [2] and Group [3]."},{"type":"html","text":"The previous IP-based total group limit (2000 requests per 10 seconds) is no longer applied."},{"type":"html","text":"The per-endpoint IP rate limit (300 requests per 10 seconds) within these groups has also been removed."}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2025-12-16.json
// module id = c8/f
// module chunks = 3